import axios from 'axios'
import { AdminStaticsObject, UsersAdmin, Withdrawal } from 'src/core/models'
import {
  AdminDeposit,
  AdminTransfer,
  PurchaseDocument
} from 'src/core/models/admin-statics.type'
import { getCarsCalculusData } from './api-helpers/car-api'
import { getParcelCalculusData } from './api-helpers/parcel-api'
import { getPlaneCalculusData } from './api-helpers/place-api'

export async function createIntegrationCertificate(
  payload: any
): Promise<{ data: any }> {
  const response = await axios.post(
    '/api/v1/integrations/generateCustomBusinessCertificate/',
    payload
  )
  return response.data.certificate
}

export async function getAdminStatics(
  currency: string
): Promise<AdminStaticsObject> {
  const url = `/api/v1/adminmanager/get_user_admin_statistics/?currency_code=${currency}`
  const { data: response } = await axios.get(url)
  return response.data
}

export const buildCalculateResponse = async (
  item: any,
  url: string,
  calculeType: any
) => {
  if (calculeType?.isCar) {
    const data = await getCarsCalculusData(item, url)
    return data
  } else if (calculeType?.isPlane) {
    const data = await getPlaneCalculusData(item, url)
    return data
  } else if (calculeType?.isParcel) {
    const data = await getParcelCalculusData(item, url)
    return data
  }
}

export const getUsersAdminAPI = async (): Promise<UsersAdmin[]> => {
  const { data } = await axios.get<UsersAdmin[]>(
    '/api/v1/adminmanager/get_users/'
  )
  return data
}

export const validateUserAPI = async (userId: number): Promise<string> => {
  const url = `/api/v1/adminmanager/validate_user/?id=${userId}`
  const { data } = await axios.post<string>(url, {})
  return data
}

export const rejectUserAPI = async (
  userId: number,
  rejectedReason: string
): Promise<string> => {
  const url = `/api/v1/adminmanager/reject_user/?id=${userId}`
  const { data } = await axios.post<string>(url, {
    rejected_reason: rejectedReason
  })
  return data
}

export const getWithdrawalsAPI = async (): Promise<Withdrawal[]> => {
  const { data } = await axios.get<{ result: Withdrawal[] }>(
    '/api/v1/adminmanager/get_withdrawals/'
  )
  return data.result
}

export const validateWithdrawalsAPI = async (
  withdrawalId: number
): Promise<string> => {
  const url = `/api/v1/adminmanager/validate_withdrawal/?id=${withdrawalId}`
  const { data } = await axios.post(url)
  return data
}

export const cancelWithdrawalsAPI = async (
  withdrawalId: number
): Promise<string> => {
  const url = `/api/v1/adminmanager/${withdrawalId}/cancel_withdrawal/`
  const { data } = await axios.patch(url, {})
  return data
}

export const getDocumentsAPI = async (): Promise<PurchaseDocument[]> => {
  const { data } = await axios.get<PurchaseDocument[]>(
    '/api/v1/orders/get_purchases/'
  )
  return data
}

export const validateCancellationAPI = async (
  documentId: number
): Promise<string> => {
  const url = '/api/v1/orders/validate_certificate/'
  const { data } = await axios.post(url, { id: documentId })
  return data
}

export const validateReceiptAPI = async (
  documentId: number
): Promise<string> => {
  const url = '/api/v1/orders/validate_receipt/'
  const { data } = await axios.post(url, { id: documentId })
  return data
}

export const validateTaxReliefAPI = async (
  documentId: number
): Promise<string> => {
  const url = '/api/v1/orders/validate_tax_relief_document/'
  const { data } = await axios.post(url, { id: documentId })
  return data
}

export const validateCarbonForwardAPI = async (
  documentId: number
): Promise<void> => {
  const url = '/api/v1/orders/validate_cfpa/'
  await axios.post(url, { id: documentId })
}

export const getTransfersAPI = async (): Promise<AdminTransfer[]> => {
  const { data } = await axios.get<AdminTransfer[]>('/api/v1/orders/getall/')
  return data
}

export const rejectTransfers = async (id: number): Promise<string> => {
  const { data } = await axios.post('/api/v1/carts/reject_transfer/', {
    id: id
  })
  return data
}

export const validateTransferAPI = async (id: number): Promise<string> => {
  const { data } = await axios.post('/api/v1/carts/validate_transfer/', {
    id
  })
  return data
}

export const getDepositsAPI = async (): Promise<AdminDeposit[]> => {
  const url = '/api/v1/adminmanager/get_deposits/'
  const { data } = await axios.get<{ result: AdminDeposit[] }>(url)
  return data.result
}

export const getFilteredInvoicesAPI = async (payload: {
    date_start: string
    date_end: string
}): Promise<string[]> => {
  const url = '/api/v1/adminmanager/get_invoice_urls_filtered/'
  const { data } = await axios.post<{ invoices: string[] }>(url, payload)
  return data.invoices
}

export const initSuppliersCronAPI = async (): Promise<void> => {
  await axios.get('/api/v1/projects/init_suppliers_info_api_cron/')
}
